import {
  WSDataItem,
  WSList,
  WSSidebar
} from "@wingspanhq/fe-component-library";
import { PayrollRun } from "@wingspanhq/wingspan-api-sdk";
import startCase from "lodash/startCase";
import React from "react";

type Props = {
  metadata: NonNullable<PayrollRun["metadata"]>;
  onClose: () => void;
};

/**
 * The run's free-form metadata, recreating the v1 screen's "Show details"
 * sidebar — which listed the invoice's display labels the same way.
 *
 * v3 `PayrollRun.metadata` is an untyped `string` map, so the keys are shown as
 * written, only split into words. Values are plain strings on v3, unlike the v1
 * labels which could hold a `Date` and needed formatting.
 */
export const PayrollRunMetadataSidebar: React.FC<Props> = ({
  metadata,
  onClose
}) => (
  <WSSidebar header="Payroll run details" size="S" onClose={onClose}>
    <WSList gap="XL">
      {Object.entries(metadata).map(([key, value]) => (
        <WSDataItem key={key} label={startCase(key)} value={value} />
      ))}
    </WSList>
  </WSSidebar>
);
